import CallError from '../../utils/CallError';
import { mapCCESItemToDetailsObject, mapECItemToDetailsObject } from '../../utils/ccesUtils';
import { getBadParams, getMissingKeys } from '../../utils/general';
import getLanguages from '../common/getLanguages';
import { settings } from './setup';

/**
 * Preview details of an app before the app is reviewed
 * @param {object} params - an object of params
 * @param {string} params.type - type of the app that you want to preview
 * @param {string} params.appId - id of the app that you want to preview
 * @param {string} params.versionId - version id of the app that you want to preview
 * @param {string} params.accessToken - ims token of the logged in user
 * @param {string} params.pluginType - plugin type of the app that you want to preview */
export default async (params = {}, signal = null) => {
  const requiredParams = ['type', 'appId', 'accessToken', 'pluginType'];
  const paramsRules = {
    type: { allowedTypes: ['string'] },
    appId: { allowedTypes: ['string'] },
    versionId: { allowedTypes: ['string'] },
    accessToken: { allowedTypes: ['string'] },
    pluginType: { allowedTypes: ['string'] },
  };
  const missingParams = getMissingKeys(params, requiredParams);
  let badParams = [];
  if (Object.keys(params).length) {
    badParams = getBadParams(params, paramsRules);
  }
  if (missingParams.length || badParams.length) {
    throw new CallError('params', null, 404, { missingParams, badParams });
  }
  const url = new URL(
    `${settings.endpoint}/v2/apps/${params.type}/${params.appId}/preview?appType=${params?.pluginType}`
  );
  if (params.versionId) {
    url.searchParams.append('versionId', params.versionId);
  }
  const response = await fetch(url.toString(), {
    signal,
    headers: {
      'x-api-key': settings.apiKey,
      Authorization: `Bearer ${params.accessToken}`,
      'x-eu-data': true,
    },
  });
  let content = await response.text();
  try {
    content = JSON.parse(content);
  } catch (e) {
    // response is not json
  }

  if (!response.ok) {
    throw new CallError('http', content, response.status, { message: response.statusText });
  } else {
    //TODO: Format below code once the ec preview API response returns data in required format

    if (params.type === 'cc') {
      const { version, versionCC, ...rest } = content?.items[0] ?? {};
      return {
        apps: [mapCCESItemToDetailsObject({ ...rest, version: version ?? versionCC })],
      };
    } else if (params.pluginType === 'ABD') {
      return {
        apps: [mapECItemToDetailsObject(content?.items[0])],
      };
    } else {
      return content;
    }
  }
};
